<template>
  <div>
    <div v-if="userRole !== 'guest'" class="innerItem">
      <button type="button" class="btn btnFull btnPrimary" @click="confirmSave" :disabled="pageLimit && (isNew || isCopy)">{{locale.save}}</button>
      <button v-if="!(isNew || isCopy)" type="button" class="mt15 btn btnFull btnWhite" @click="setVersionHistory(true)">{{locale.versionhistory}}</button>
    </div>
    <!-- 다른사이트 컨텐츠 복사 -->
    <div v-if="isSuperadmin" class="innerItem">
      <button type="button" class="btn btnFull btnLightGrey" @click="importPageLayer = true"><i style="font-family: none">⚠️</i> 페이지 불러오기</button>
    </div>
    <!-- //다른사이트 컨텐츠 복사 -->
    <!-- state -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.state}}</div>
      <span class="checkbox radio">
        <input type="radio" name="page_state" id="state_on" value="01" v-model="info.state">
        <label for="state_on">{{locale.state_public}}</label>
      </span>
      <span class="checkbox radio">
        <input type="radio" name="page_state" id="state_off" value="02" v-model="info.state">
        <label for="state_off">{{locale.state_private}}</label>
      </span>
    </div>
    <!-- //state -->
    <!-- responsive setting -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.edit_mode}}</div>
      <select name="" id="" class="input" v-model="responsiveMode">
        <option v-for="mode in responsiveList"
          :key="mode"
          :value="mode">
          {{locale[mode]}}
        </option>
      </select>
      <div class="mt5">
        <span class="checkbox">
          <input type="checkbox" id="display_mods_hide" @change="displayHideMods">
          <label for="display_mods_hide">{{locale.hide_hidden_module}}</label>
        </span>
      </div>
    </div>
    <!-- responsive setting -->
    <!-- change language value -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.language}}</div>
      <select name="" id="" class="input" v-model="langs.current">
        <option v-for="lang in usableList" :key="lang.c"
          :value="lang.c"
          :disabled="isNew && lang.c !== langs.default">
          {{ langName(lang.c) }}
        </option>
      </select>
      <p class="mt5 f_light colorGrey">{{langMessage}}</p>
    </div>
    <!-- //change language value -->
    <!-- title -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.title}}</div>
      <input type="text" class="input" v-model="info.title">
      <div class="mt10">
        <span class="checkbox mb5">
          <input type="checkbox" id="page_pid_active" v-model="info.pIdActive">
          <label for="page_pid_active">{{locale.product_id}}</label>
        </span>
        <input type="text" class="input" v-model="info.pId">
      </div>
      <div v-if="info.pIdActive" class="mt10">
        <p class="colorGrey mb5">{{locale.pidtype}}</p>
        <select class="input" v-model="info.pIdTypeId" @change="setPidType">
          <option v-for="pid in pIdType"
            :key="pid.id"
            :value="pid.id">
            {{pid.id === '#none' ? locale.none : pid.label}}
          </option>
        </select>
      </div>
    </div>
    <!-- //title -->
    <!-- load product info -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.page_import_product}}</div>
      <p class="sysMessage">{{locale.page_import_product_message}}</p>
      <span class="checkbox">
        <input type="checkbox" id="link_product" v-model="info.product_link" @change="productLink">
        <label for="link_product">{{locale.use_import}}</label>
      </span>
      <div v-if="info.product_link && !(itemModule.find(x => x.name === 'quantity')
          && itemModule.find(x => x.name.includes('button') && x.dataSet.column.find(c => c.detail.button.type === 'submit')))" class="messageBox">
        {{locale.page_import_product_warning}}
      </div>
      <div v-if="info.product_link" class="mt10">
        <div v-if="info.product_link && info.product_item">{{info.product_name}}</div>
        <div v-else-if="!info.product_item">{{locale.page_import_product_select}}</div>
        <button type="button" class="btn btnFull mt10" @click="setLoadProduct(true)">{{locale.select_product}}</button>
      </div>
    </div>
    <!-- //load product info -->
    <!-- thumbnail -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.thumbnail}}</div>
      <div v-if="info.thumbnail !== ''" class="setThumbnail">
        <div class="thumb">
          <img :src="info.thumbnail" alt="">
          <button type="button" class="delThumb" @click="deleteThumbnail"><span class="blind">delete</span></button>
        </div>
      </div>
      <div v-else>
        <input type="file" id="cart_thumbnail" @change="uploadThumbnail">
        <label for="cart_thumbnail" class="btn btnFull btnWhite">upload</label>
      </div>
    </div>
    <!-- //thumbnail -->
    <!-- category -->
    <div class="innerItem categoryBox">
      <div class="label mb5 setLabel">{{locale.category}}</div>
      <ul class="categoryPath" v-if="checkedPath.length">
        <li v-for="(id, index) in checkedPath" :key="`${id}_${index}`">
          <span v-for="(path, index) in categoryPath(id)" :key="index">
            {{path}}
          </span>
        </li>
      </ul>
      <div v-else>{{locale.category_nodata}}</div>
      <button type="button" class="btn btnWhite btnFull mt10" @click="categoryOpen = !categoryOpen">{{locale.category_setting}}</button>
      <CategoryList class="mt10"
        v-show="categoryOpen"
        :mode="'compact'"
        :option="categoryOption"
        :setCheck="info.category" />
    </div>
    <!-- //category -->
    <!-- submit settings :: code -->
    <div>
      <div class="innerItem">
        <div class="label mb5 setLabel setLabel">{{locale.submit}}</div>
        <p class="sysMessage">
          <router-link v-if="userRole === 'admin'"
            :to="{name: 'admin', params: {admin: 'codelist'}}"
            data-nav="admin">
            {{`[${locale.submit_category_setting}] ${locale.nav_admin} > ${locale.admin_codelist}`}}
          </router-link>
          <span v-else>{{`[${locale.submit_category_setting}] ${locale.message_admin_only}`}}</span>
        </p>
        <SetSubmitCate :submitData="submitData" />
        <!-- 주문자 정보입력 -->
        <div class="mt10">
          <div class="checkbox">
            <input type="checkbox" id="userInfoInput" :checked="typeof (submitData.userInfoInput) === 'undefined' ? true : submitData.userInfoInput" @change="setUserInfoInput">
            <label for="userInfoInput">{{locale.activate_user_info_input}}</label>
          </div>
        </div>
        <!-- //주문자 정보입력 -->
        <!-- 장바구니 활성화 -->
        <div class="setCart mt10">
          <div class="checkbox">
            <input type="checkbox" id="setCart" :checked="submitData.cart" @change="setCart">
            <label for="setCart">{{locale.activate_cart}}</label>
          </div>
        </div>
        <!-- //장바구니 활성화 -->
        <!-- 장바구니 제목 -->
        <div class="mt10">
          <p class="setSubLabel mb5">{{locale.title_cart}}</p>
          <SetLanguageValue
            :locale="locale"
            :langValue="submitData.subject" />
          <!-- <div class="translation">
            <input type="text" class="input" v-model="submitData.subject[langs.default]" @focusout="setDefaultVal">
            <button type="button" class="btnTranslation" :title="locale.language_specific_set" @click="onCartSubjectOpen">
              <span class="blind">{{locale.language_specific_set}}</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512" height="512"><g id="outline"><path d="M71.008,183.859,99,206.25A8,8,0,0,0,112,200V176h34c-.1.146-.226.283-.329.43a136.11,136.11,0,0,0,57.883,205.109c.211.086.429.164.648.234A135.616,135.616,0,0,0,256,392a137.9,137.9,0,0,0,24-2.129V440a32.032,32.032,0,0,0,32,32H424a32.032,32.032,0,0,0,32-32V367.383a39.852,39.852,0,0,0-15.008-31.242L413,313.75A8,8,0,0,0,400,320v24H359.5c2.225-2.613,4.472-5.211,6.491-7.976.031-.04.064-.076.1-.117s.057-.067.083-.1A136.03,136.03,0,0,0,256,120a137.9,137.9,0,0,0-24,2.129V80a32.032,32.032,0,0,0-32-32H88A32.032,32.032,0,0,0,56,80v72.617A39.852,39.852,0,0,0,71.008,183.859ZM408,360a8,8,0,0,0,8-8V336.641l14.992,11.992A23.906,23.906,0,0,1,440,367.383V440a16.021,16.021,0,0,1-16,16H312a16.021,16.021,0,0,1-16-16V376a16.021,16.021,0,0,1,16-16Zm-85.725-16q1.952-7.046,3.563-14.112Q335.9,332.2,346,335.273c-2.692,3.055-5.56,5.948-8.55,8.727Zm34.063-22.282q-13.658-4.4-27.277-7.5A324.916,324.916,0,0,0,334.2,264h41.5A119.068,119.068,0,0,1,356.338,321.718Zm.145-131.214A118.789,118.789,0,0,1,375.691,248H334.2a323.384,323.384,0,0,0-5.125-50.036Q342.938,194.822,356.483,190.5Zm-10.277-13.583q-10.067,3.023-20.317,5.362-3.323-14.64-8.128-29.137A119.3,119.3,0,0,1,346.206,176.921ZM264,136.314a119.479,119.479,0,0,1,33.258,7.09,298.5,298.5,0,0,1,12.961,42.11A310.41,310.41,0,0,1,264,190.167Zm0,69.881a326.175,326.175,0,0,0,49.4-5,307.007,307.007,0,0,1,4.8,46.8H264ZM264,264H318.2a308.575,308.575,0,0,1-4.8,46.941A326.084,326.084,0,0,0,264,305.829Zm0,57.831a310.731,310.731,0,0,1,46.176,4.783q-2.089,9.087-4.726,18.071a31.955,31.955,0,0,0-25.195,28.8A118.573,118.573,0,0,1,264,375.64ZM155.512,190.512q12.942,4.15,25.833,7.111A325.253,325.253,0,0,0,176.2,248H136.309A118.879,118.879,0,0,1,155.512,190.512Zm10.257-13.577q.415-.468.838-.935h19.317c-.5,2-.951,3.96-1.406,5.941Q175.164,179.765,165.769,176.935ZM155.384,321.26A118.849,118.849,0,0,1,136.308,264h39.9a324.516,324.516,0,0,0,5.138,50.2Q168.435,317.155,155.384,321.26Zm10.259,13.609q9.494-2.819,18.891-4.982,3.207,14.038,7.67,27.719A120.364,120.364,0,0,1,165.643,334.869ZM248,375.671a121.547,121.547,0,0,1-35.183-7.794,298.271,298.271,0,0,1-12.623-41.254A302.426,302.426,0,0,1,248,321.765Zm0-69.86a332.354,332.354,0,0,0-50.989,5.142A307.941,307.941,0,0,1,192.2,264H248ZM248,248H192.2a308.706,308.706,0,0,1,4.8-47.084A325.631,325.631,0,0,0,248,206.191ZM232,144v-5.54a118.972,118.972,0,0,1,16-2.106v53.814a309.782,309.782,0,0,1-47.824-4.93q1.1-4.733,2.369-9.5A31.932,31.932,0,0,0,232,144ZM72,80A16.021,16.021,0,0,1,88,64H200a16.021,16.021,0,0,1,16,16v64a16.021,16.021,0,0,1-16,16H104a8,8,0,0,0-8,8v15.359L81.008,171.367A23.906,23.906,0,0,1,72,152.617Z"/><circle cx="144" cy="108" r="12"/><circle cx="188" cy="108" r="12"/><circle cx="100" cy="108" r="12"/><circle cx="368" cy="412" r="12"/><circle cx="412" cy="412" r="12"/><circle cx="324" cy="412" r="12"/></g></svg>
            </button>
          </div>
          <LangValue v-show="cartSubjectOpen"
            :langValue="langValue"
            :title="locale.language_specific_set"
            @close="onCartSubjectClose" /> -->
        </div>
        <!-- //장바구니 제목 -->
      </div>
      <!-- 전송 완료 후 링크 (기본: Complete) -->
      <div class="innerItem">
        <div class="label mb5 setLabel setLabel">{{locale.submit_complete_page}}</div>
        <p class="sysMessage">{{locale.message_submit_complete_page}}</p>
        <div class="checkbox">
          <input type="checkbox" name="submit_returnUrl" id="submit_returnUrl_link" v-model="submitData.submitReturnUrl">
          <label for="submit_returnUrl_link">{{locale.set_link}}</label>
        </div>
        <div v-if="submitData.submitReturnUrl" class="mt10">
          <SetLink
            :link="submitData.submitReturnUrlLink" />
        </div>
      </div>
      <!-- //전송 완료 후 링크 (기본: Complete) -->
    </div>
    <!-- //submit settings :: code -->
    <!-- 전송카테고리(알림톡 등 전송과 함께 부가적으로 처리하기 위한 코드) -->
    <div v-if="typeof(submitData) !== 'undefined' && submitData.isSubmit && submitCategory && submitCategory.length > 1">
      <div class="innerItem">
        <div class="label mb5 setLabel setLabel">{{locale.admin_submitcategory}}</div>
        <p class="sysMessage">{{locale.submitcategory_sys_message}}</p>
        <select name="" id="" class="input" v-model="submitData.submitCategoryId" @change="setSubmitCategory">
          <option
            v-for="cate in submitCategory"
            :key="cate.id"
            :value="cate.id">
            {{cate.id === '#none' ? locale.none : cate.label}}
            </option>
        </select>
      </div>
    </div>
    <!-- //전송카테고리(알림톡 등 전송과 함께 부가적으로 처리하기 위한 코드) -->
    <!-- submit settings :: guest type -->
    <div v-if="typeof(submitData) !== 'undefined' && submitData.isSubmit && hasGuestType">
      <div class="innerItem">
        <div class="label mb5 setLabel setLabel">{{locale.guesttype_setting}}</div>
        <button type="button" class="btn btnWhite btnFull" @click="setGuestType">{{locale.change}}</button>
      </div>
    </div>
    <!-- //submit settings :: guest type -->
    <!-- submit settings :: available -->
    <div v-if="submitData && submitData.isSubmit" class="innerItem setAvailable">
      <div class="label mb5 setLabel">{{locale.page_set_available}}</div>
      <div class="mb10">
        <span class="checkbox radio">
          <input type="radio" name="page_available" id="page_available_always" value="01" v-model="info.available.state">
          <label for="page_available_always">{{locale.page_available_always}}</label>
        </span>
        <span class="checkbox radio">
          <input type="radio" name="page_available" id="page_available_each" value="02" v-model="info.available.state">
          <label for="page_available_each">{{locale.page_available_each}}</label>
        </span>
      </div>
      <button type="button" class="btn btnWhite btnFull" @click="setAvailableTime(true)">{{locale.setting}}</button>
      <AvailableTime
        v-if="availableLayer"
        :locale="locale"
        :available="info.available"
        @apply="applyAvailableTime"
        @close="setAvailableTime(false)" />
    </div>
    <!-- //submit settings :: available -->
    <!-- submit settings:: advanced -->
    <div class="innerItem">
      <div class="label mb5 setLabel">{{locale.advanced_settings}}</div>
      <div v-if="submitData && submitData.isSubmit" class="mt10">
        <div class="checkbox">
          <input type="checkbox" id="submit_required_coupon" v-model="submitData.requiredCoupon">
          <label for="submit_required_coupon">{{locale.required_coupon}}</label>
        </div>
      </div>
      <div class="mt10">
        <div class="checkbox">
          <input type="checkbox" id="submit_hidden_price" v-model="submitData.hiddenPrice">
          <label for="submit_hidden_price">{{locale.hidden_price}}</label>
        </div>
      </div>
      <div class="mt10">
        <div class="checkbox">
          <input type="checkbox" id="submit_required_auth" v-model="info.requiredAuth">
          <label for="submit_required_auth">{{locale.page_required_auth}}</label>
        </div>
        <div class="mt10 ml15">
          <div class="checkbox">
            <input type="checkbox" id="submit_auth_hidden_id" v-model="info.requiredAuthIdHidden">
            <label for="submit_auth_hidden_id">{{locale.page_required_auth_id}}</label>
          </div>
          <div class="mt10"><p class="sysMessage">{{locale.message_page_required_auth}}</p></div>
          <div class="mt5"><input type="text" class="input" placeholder="user.site" v-model="info.requiredAuthId"></div>
        </div>
      </div>
    </div>
    <!-- //submit settings:: advanced -->
    <!-- load product layer -->
    <div v-if="loadProductLayer" class="layer loadProductLayer">
      <div class="inner">
        <button type="button" class="btnClose" @click.stop="setLoadProduct(false)"><span class="blind">close</span></button>
        <h2 class="layerTitle">{{locale.product_information}}</h2>
        <div class="loadProductBox">
          <div class="loadProductList">
            <ul v-if="loadProductInfo.list.length">
              <li class="mb5"
                v-for="item in loadProductInfo.list"
                :key="item.id">
                <span class="checkbox radio">
                  <input
                    type="radio"
                    name="load_product"
                    :id="`load_product_${item.id}`"
                    :checked="info.product_list === item.id"
                    :value="item.id"
                    @input="getProductItem(item.id)">
                  <label :for="`load_product_${item.id}`">{{item.title}}</label>
                </span>
              </li>
            </ul>
            <p v-else class="noData">{{locale.product_list_nodata}}</p>
          </div>
          <div class="loadProductItem">
            <ul v-if="loadProductInfo.item.length">
              <li v-for="item in loadProductInfo.item"
                :key="item.id">
                <span class="checkbox radio">
                  <input
                    type="radio"
                    name="load_product_item"
                    :id="`load_product_item_${item.id}`"
                    :checked="info.product_item === item.id"
                    :value="item.id"
                    @input="getProductItemInfo(item.id)">
                  <label :for="`load_product_item_${item.id}`">
                    <div class="thumb">
                      <img :src="item.thumb" alt="">
                    </div>
                    {{item.info.pName}}
                  </label>
                </span>
              </li>
            </ul>
            <p v-else class="noData">{{loadProductInfo.listId ? locale.product_nodata : locale.select_product_list}}</p>
          </div>
        </div>
        <div class="btns">
          <button type="button" class="btn btnPrimary btnFull" @click.stop="updateLoadProduct">{{locale.apply}}</button>
        </div>
      </div>
    </div>
    <!-- //load product layer -->
    <!-- 고객식별타입 세팅 -->
    <GuestType v-if="guestTypeLayer"
      :locale="locale"
      :guestType="info.guestType"
      :defaultValue="true"
      @apply="updateGuestType"
      @close="setGuestType" />
    <!-- //고객식별타입 세팅 -->
    <!-- 저장 전 메모 -->
    <Memo v-if="saveMemoLayer"
      :locale="locale"
      @save="saveMemo"
      @close="closeMemo" />
    <!-- //저장 전 메모 -->
    <!-- 버전히스토리 -->
    <VersionHistory v-if="versionHistory.active"
      :locale="locale"
      :file="versionHistory.file"
      :currentVer="currentVer"
      @load="loadVersion"
      @close="setVersionHistory(false)" />
    <!-- //버전히스토리 -->
    <!-- 버전파일 불러오기 -->
    <ImportVersionFile v-if="importPageLayer"
      :locale="locale"
      @load="importPage"
      @close="importPageLayer = false" />
    <!-- //버전파일 불러오기 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UNIQUE from '@/common/unique'
import LANG from '@/common/lang'
import regExp from '@/common/regExp'
import UTIL from '@/common/util'
import CategoryList from '@/components/Category/List'
import SetSubmitCate from '@/components/Util/SetSubmitCate'
import LangValue from '@/components/Util/LangValue.vue'
import GuestType from '@/components/Util/GuestType.vue'
import SetLink from '@/components/Util/SetLink'
import AvailableTime from '@/components/Util/AvailableTime'
import VersionHistory from '@/components/Util/VersionHistory'
import Memo from '@/components/Util/Memo'
import ImportVersionFile from '@/components/Util/ImportVersionFile'
import SetLanguageValue from '@/components/Util/SetLanguageValue'

const defaultAvailable = function () {
  const list = [
    { id: 'mon', name: '월', available: true, time: { from: '00:00', to: '00:00' } },
    { id: 'tue', name: '화', available: true, time: { from: '00:00', to: '00:00' } },
    { id: 'wed', name: '수', available: true, time: { from: '00:00', to: '00:00' } },
    { id: 'thu', name: '목', available: true, time: { from: '00:00', to: '00:00' } },
    { id: 'fri', name: '금', available: true, time: { from: '00:00', to: '00:00' } },
    { id: 'sat', name: '토', available: true, time: { from: '00:00', to: '00:00' } },
    { id: 'sun', name: '일', available: true, time: { from: '00:00', to: '00:00' } }
  ]
  return {
    state: '01',
    set: list
  }
}

export default {
  name: 'SetPageItem',
  components: {
    CategoryList,
    SetSubmitCate,
    LangValue,
    GuestType,
    SetLink,
    AvailableTime,
    VersionHistory,
    Memo,
    ImportVersionFile,
    SetLanguageValue
  },
  props: [
    'locale',
    'currentVer',
    'pageLimit',
    'submitLimit',
    'itemModule',
    'isNew',
    'isCopy',
    'info',
    'langs',
    'text',
    'submitData'
  ],
  computed: {
    ...mapGetters({
      categoryPath: 'category/categoryPath',
      categoryName: 'category/categoryName',
      checkedCategory: 'category/getChecked'
    }),
    isSuperadmin () {
      return this.$store.getters['authentication/getAuthority']
    },
    pIdType () {
      return this.$store.state.admin.pidType
    },
    submitCategory () {
      return this.$store.state.admin.submitCategory
    },
    hasGuestType () {
      return this.$store.state.setting.guestType && this.$store.state.setting.guestType.length > 0
    },
    langValue: {
      get () {
        return this.submitData.subject || this.$store.getters['setting/getLangValues']()
      },
      set (val) {
        // this.setDefaultVal(val)
      }
    },
    userRole () {
      return this.$store.getters['authentication/getAuthInfo'].userRole
    },
    usableList () {
      return this.langs.info.filter(x => {
        return this.langs.usable.indexOf(x.c) !== -1
      })
    },
    responsiveMode: {
      get () {
        return this.info.responsive
      },
      set (mode) {
        this.$emit('updateResponsive', mode)
      }
    },
    langMessage () {
      const langs = this.langs
      const current = langs.current
      let message
      if (this.isNew) {
        message = this.locale.page_language_disabled_default_message
      } else {
        if (langs.manual.includes(current)) {
          message = null
        } else {
          message = this.locale.translate_auto_message
        }
      }
      return message
    },
    setTime () {
      const interval = [ '00', '30' ]
      let list = []
      for (let i = 0; i <= 24; i++) {
        for (let j = 0; j < interval.length; j++) {
          list.push(`${('0' + i).slice(-2)}:${interval[j]}`)
        }
      }
      list.pop()
      return list
    },
    checkedPath () {
      return this.checkedCategory
    }
  },
  created () {
    this.$store.dispatch('admin/getSubmitCategory')
    this.$store.dispatch('admin/getPidType')
    if (!this.info.available) {
      this.info.available = defaultAvailable()
    }
  },
  watch: {
    info: {
      deep: true,
      handler: function (info) {
        this.setCheckedCategory(this.info.category)
      }
    }
    /*
    submitData: {
      deep: true,
      handler: function (submit) {
        if (submit.isSubmit && submit.submitTo === '') {
          const submitTo = this.$store.state.superadmin.category[0]
          console.log(submitTo)
          const data = {
            submitTo: submitTo,
            submitLabel: submitLabel
          }
          this.$store.dispatch('page/setSubmitTo', data)
        }
      }
    }
    */
  },
  data () {
    let thumbnail = this.info.thumbnail || ''
    return {
      responsiveList: [
        'mobile',
        'tablet'
      ],
      viewMode: [
        'mobile'
      ],
      categoryOpen: false,
      categoryOption: {
        editItem: false,
        checkbox: true,
        unCategorized: false
      },
      cartSubjectOpen: false,
      thumbnail,
      loadProductLayer: false,
      loadProductInfo: {
        list: [],
        item: [],
        listId: null,
        itemId: null
      },
      guestTypeLayer: false,
      availableLayer: false,
      versionHistory: {
        active: false,
        file: ''
      },
      saveMemoLayer: false,
      importPageLayer: false
    }
  },
  methods: {
    onCartSubjectOpen () {
      this.cartSubjectOpen = true
    },
    onCartSubjectClose () {
      this.cartSubjectOpen = false
    },
    setDefaultVal () {
      const target = this.submitData.subject
      const defaultLang = this.langs.default
      const fillLangs = UTIL.fillLangs(target, target[defaultLang])
      this.$store.dispatch('page/setSubmitData', { key: 'subject', value: fillLangs })
    },
    setSubmitData (data) {
      const key = data.key
      const value = data.value
      this.$store.dispatch('page/setSubmitData', { key: key, value: value })
    },
    setSubject (e) {
      const value = e.target.value
      const defaultLang = this.langs.default
      const subject = Object.assign(this.submitData.subject, { [defaultLang]: value })
      this.setSubmitData({ key: 'subject', value: subject })
    },
    setCart (e) {
      const checked = e.target.checked
      // this.$store.dispatch('page/setSubmitData', { key: 'cart', value: checked })
      this.setSubmitData({ key: 'cart', value: checked })
    },
    setUserInfoInput (e) {
      const checked = e.target.checked
      this.setSubmitData({ key: 'userInfoInput', value: checked })
    },
    uploadThumbnail (e) {
      this.$emit('uploadThumbnail', e)
    },
    deleteThumbnail () {
      this.$emit('deleteThumbnail')
    },
    setAvailableTime (isOpen) {
      this.availableLayer = isOpen
    },
    applyAvailableTime (data) {
      this.info.available = data
      this.setAvailableTime(false)
    },
    langName (c) {
      const code = `lang_${c}`
      const translate = this.langs.manual.includes(c) ? 'translate_manual' : 'translate_auto'
      const isDefault = this.langs.default === c ? `(${this.locale.setting_language_default})` : ''
      return `${this.locale[code]} - ${this.locale[translate]}${isDefault}`
    },
    // 연결상품 리스트
    setLoadProduct (open) {
      function getList (arr) {
        const sort = 'updated'
        const list = arr.map(x => x).sort(function (a, b) {
          return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
        })
        return list
      }
      if (open) {
        this.loadProductLayer = true
        this.$store.commit('onLoading', true)
        this.$store.dispatch('product/getProductList').then((res) => {
          this.loadProductInfo.list = getList(res)
          if (res && this.info.product_item) {
            this.getProductItem(this.info.product_list)
          }
          this.$store.commit('onLoading', false)
        })
      } else {
        if (window.confirm(this.locale.confirm_cancel)) {
          this.loadProductLayer = false
        }
      }
    },
    // 연결상품 아이템 리스트
    getProductItem (id) {
      this.$store.commit('onLoading', true)
      this.$store.dispatch('product/getProductItem', id).then((res) => {
        this.loadProductInfo.listId = id
        this.loadProductInfo.item = res.items
        this.$store.commit('onLoading', false)
      })
    },
    // 연결상품 아이템 정보
    getProductItemInfo (id) {
      this.loadProductInfo.itemId = id
    },
    updateLoadProduct () {
      const list = this.loadProductInfo.listId
      const product = this.loadProductInfo.itemId
      if (product) {
        if (window.confirm(this.locale.confirm_import_product)) {
          const item = this.loadProductInfo.item.find(x => x.id === product)
          const data = {
            product_list: list,
            product_item: item.id,
            product_name: item.info.pName,
            available: item.available,
            thumbnail: item.thumb,
            price: item.info.price,
            min: item.info.min,
            max: item.info.max
          }
          const submit = {
            cart: true,
            isSubmit: true,
            submitTo: item.submitTo,
            submitLabel: item.info.pName,
            subject: item.info.name
          }
          this.$emit('updateLoadProduct', data)
          this.$store.dispatch('page/setSubmit', submit)
          this.loadProductLayer = false
        }
      } else {
        alert(this.locale.alert_select_import_product)
      }
    },
    productLink (e) {
      const isLinked = e.target.checked
      this.$emit('isLoadProduct', isLinked)
    },
    setCheckedCategory: function (ids) {
      this.$store.commit('category/updateCheckedState', ids)
    },
    availableState () {
      const always = this.available.state === '01'
      if (always) {
        this.available.set.forEach(function (x) {
          x.available = true
          x.timeFrom = '00:00'
          x.timeTo = '24:00'
        })
      }
    },
    isNextDay (from, to) {
      from = from ? regExp.numberOnly(from) : 0
      to = to ? regExp.numberOnly(to) : 0
      return to < from
    },
    setPidType () {
      const id = this.info.pIdTypeId
      this.info.pIdType = this._.cloneDeep(this.pIdType.find(x => x.id === id))
    },
    setSubmitCategory () {
      const id = this.submitData.submitCategoryId
      this.submitData.submitCategory = this._.cloneDeep(this.submitCategory.find(x => x.id === id))
    },
    displayHideMods (e) {
      const isChecked = e.target.checked
      this.$emit('displayHideMods', isChecked)
    },
    setGuestType () {
      this.guestTypeLayer = !this.guestTypeLayer
    },
    updateGuestType (guestType) {
      this.info.guestType = guestType
    },
    confirmSave () {
      this.saveMemoLayer = true
    },
    saveMemo (memo) {
      this.$emit('saveMemo', memo)
      setTimeout(() => {
        this.closeMemo()
      }, 500)
      // this.save()
    },
    closeMemo () {
      this.saveMemoLayer = false
    },
    save: function () {
      this.$emit('save')
    },
    importPage (data) {
      this.loadVersion(data.version, data.site, data.id)
      this.importPageLayer = false
    },
    // 버전히스토리
    setVersionHistory (isActive) {
      const pageId = this.$route.params.id
      this.versionHistory.active = isActive
      this.versionHistory.file = `page/item/${pageId}.json`
    },
    loadVersion (version, site, id) {
      this.$emit('loadVersion', version, site, id)
      setTimeout(() => {
        this.versionHistory.active = false
        this.versionHistory.file = ''
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.setThumbnail .thumb {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px solid $color-lgrey2;
  background-color: $color-white;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .delThumb {
    position: absolute;
    top: -6px;
    left: 100%;
    width: 16px;
    height: 16px;
    margin-left: -4px;
    border-radius: 100%;
    background: $color-dark url('~@/assets/img/ico_close.svg') 50% 50% / 8px no-repeat;
  }
}
.loadProductLayer {
  .inner {
    max-width: 900px;
  }
  .loadProductBox {
    display: flex;
    .loadProductList {
      flex: 1;
      min-height: 400px;
      padding-right: 15px;
    }
    .noData {
      padding-top: 150px;
      text-align: center;
    }
    .loadProductItem {
      flex: 3;
      max-height: 720px;
      overflow: auto;
      padding-left: 15px;
      border-left: 1px solid $color-lgrey2;
      ul {
        display: flex;
        flex-wrap: wrap;
      }
      li {
        position: relative;
        width: calc(25% - 8px);
        margin-bottom: 8px;
        margin-right: 8px;
        text-align: center;
        border: 1px solid $color-lgrey2;
        border-radius: 4px;
        background-color: $color-white;
      }
      .checkbox {
        display: block;
        position: static;
        margin-right: 0;
        label {
          padding: 8px;
          &:before {
            top: 8px;
            left: 8px;
          }
        }
      }
      .thumb {
        width: 60px;
        height: 60px;
        margin: 0 auto 5px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .btns {
    max-width: 480px;
    margin: 30px auto 0;
    text-align: center;
  }
}
.messageBox {
  position: relative;
  margin-top: 8px;
  padding: 8px;
  font-size: 0.85em;
  color: $color-white;
  border-radius: 4px;
  background-color: $color-red;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 8px;
    width: 6px;
    height: 8px;
    margin-top: -4px;
    border-radius: 2px;
    background-color: $color-red;
    transform: rotate(45deg);
  }
}
</style>
